import { combineEnhancers, HAPIEndpointEnhancer, TokenInjectionEnhancer, PIFDEndpointEnhancer, JarvisEndpointEnhancer, MicrosoftFlightEnhancer, HAPIWithMicrosoftTestHeader } from '@microsoft-commerce/purchase-blends-component-library';
import { isDevelopmentEnvironment } from '@shared/utils/checkoutUtils';
import { Constants } from '@shared/utils/constants';
const getCommerceToken = (retrieveTokens)=>()=>`${Constants.Headers.Bearer} ${retrieveTokens().commerce}`;
const getPifdToken = (retrieveTokens)=>()=>`${Constants.Headers.Bearer} ${retrieveTokens().pifd}`;
const getJarvisToken = (retrieveTokens)=>()=>`${Constants.Headers.Bearer} ${retrieveTokens().jarvis}`;
export const getEnhancer = ({ testUser, siteEnvironment, retrieveTokens })=>{
    const enhancers = [
        HAPIEndpointEnhancer(TokenInjectionEnhancer(()=>getCommerceToken(retrieveTokens))),
        PIFDEndpointEnhancer(TokenInjectionEnhancer(()=>getPifdToken(retrieveTokens))),
        JarvisEndpointEnhancer(TokenInjectionEnhancer(()=>getJarvisToken(retrieveTokens))),
        HAPIEndpointEnhancer(MicrosoftFlightEnhancer('WSFB_ComplexOrgs')),
        HAPIEndpointEnhancer(MicrosoftFlightEnhancer('WSFB_CatalogPricingEnhancement'))
    ];
    if (isDevelopmentEnvironment(siteEnvironment) || testUser) {
        enhancers.push(HAPIWithMicrosoftTestHeader);
    }
    return combineEnhancers(...enhancers);
};
